import { render, staticRenderFns } from "./RemindRecordDialog.vue?vue&type=template&id=250e26ee&scoped=true"
import script from "./RemindRecordDialog.vue?vue&type=script&lang=js"
export * from "./RemindRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./RemindRecordDialog.vue?vue&type=style&index=0&id=250e26ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250e26ee",
  null
  
)

export default component.exports